// extracted by mini-css-extract-plugin
export var arrowWrapper = "fb_f0";